import { MouseEvent, ReactNode } from "react";
import { PopoverProps } from "antd";
import clsx from "clsx";
import { UserBubble } from "../user-bubble";
import "./user-bubble-link-text.scss";

type UserBubbleLinkTextProps = {
  userId?: string;
  children: ReactNode;
  trigger?: PopoverProps["trigger"];
  className?: string;
  onClick?: (event: MouseEvent<HTMLSpanElement>) => void;
};

export const UserBubbleLinkText = ({
  userId,
  children,
  trigger,
  className,
  onClick,
}: UserBubbleLinkTextProps) => {
  const content = (
    <span
      className={clsx("user-bubble-link-text", className)}
      onClick={onClick}
    >
      {children}
    </span>
  );

  if (!userId) {
    return content;
  }

  return (
    <UserBubble userId={userId} trigger={trigger}>
      {content}
    </UserBubble>
  );
};
